import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  CardContent,
  Divider,
  Chip,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useStyles } from "../../../theme/appStyles";
import {
  useDeleteProductMutation,
  useGetBrandQuery,
  useGetCategoryQuery,
  useGetMainItemQuery,
  useDeleteMainItemMutation,
  useGetTagQuery,
  useGetPrinterQuery,
  useGetProductWithStoreQuery,
  useGetStoreQuery,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IMainItem,
  IVariantView,
  IStore,
  IBrand,
  ITag,
  IPrinter,
} from "../../../Api/Interface/api.interface";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import NewPopupTenant from "../Edit/index";
import ProductionQuantityLimitsOutlinedIcon from "@mui/icons-material/ProductionQuantityLimitsOutlined";
import NewPopUpProduct from "../../Product/Edit/index";
import { useNotifier } from "../../../Core/Notifier";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import { FcPicture } from "react-icons/fc";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import AlertPopUp from "../../../Components/AlertPopUp/AlertPopup";

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    default:
      return "";
  }
};

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [selectCustomer, setSelectCustomer] = useState<IMainItem | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<IVariantView | null>(
    null
  );
  const [openDialogProduct, setOpenDialogProduct] = useState(false);
  const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
  const [productToDelete, setProductToDelete] = useState<IVariantView | null>(
    null
  );
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [openDialogProductMI, setOpenDialogProductMI] = useState(false);
  const [openDeleteProductMI, setOpenDeleteProductMI] = useState(false);
  const [productToDeleteMI, setProductToDeleteMI] = useState<IMainItem | null>(
    null
  );
  const { id: ProductId } = useParams<{ id: string }>();

  useEffect(() => {}, [ProductId]);

  const { data, isLoading, isError } = useGetMainItemQuery({
    searchText: "",
    id: String(ProductId),
    variantBrandId: null,
    categoryId: null,
    variantTagId: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });

  const {
    data: productData,
    isLoading: productIsLoading,
    isError: productIsError,
  } = useGetProductWithStoreQuery({
    searchText: "",
    id: null,
    variantBrandId: null,
    categoryId: null,
    variantTagId: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
    mainItemId: String(ProductId),
  });

  const { data: storeData, isLoading: storeIsLoading } = useGetStoreQuery({
    searchText: "",
  });

  const { data: productBrandData, isLoading: brandIsLoading } =
    useGetBrandQuery({
      searchText: "",
      isActive: "1",
      id: "",
    });
  const { data: productTagData, isLoading: ProductTagLoading } = useGetTagQuery(
    {
      searchText: "",
      isActive: "1",
      id: "",
    }
  );

  const { data: printerData, isLoading: PrinterLoading } = useGetPrinterQuery({
    searchText: "",
  });

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery();

  const product = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as IMainItem;
    }
    return null;
  }, [data]);

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const getAllStoreList = useMemo(() => {
    return storeData?.data as IStore[];
  }, [storeData?.data]);

  const productBrandList = useMemo(() => {
    return productBrandData?.data as IBrand[];
  }, [productBrandData?.data]);

  const productTagList = useMemo(() => {
    return productTagData?.data as ITag[];
  }, [productTagData?.data]);

  const printerList = useMemo(() => {
    return printerData?.data as IPrinter[];
  }, [printerData?.data]);

  const categoryMap = useMemo(() => {
    const map = new Map();
    categoryList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [categoryList]);

  const productBrandMap = useMemo(() => {
    const map = new Map();
    productBrandList?.forEach((brand) => {
      map.set(brand.id, brand.brandName);
    });
    return map;
  }, [productBrandList]);

  const tagMap = useMemo(() => {
    const map = new Map();
    productTagList?.forEach((brand) => {
      map.set(brand.id, brand.tagName);
    });
    return map;
  }, [productTagList]);

  const printerMap = useMemo(() => {
    const map = new Map();
    printerList?.forEach((brand) => {
      map.set(brand.id, brand.printerName);
    });
    return map;
  }, [printerList]);

  const getStoreMap = useMemo(() => {
    const map = new Map();
    getAllStoreList?.forEach((category) => {
      map.set(category.id, category.storeName);
    });
    return map;
  }, [getAllStoreList]);

  const handleOpenEditTenant = () => {
    setSelectCustomer(product);
    setOpenDialog(true);
  };

  const handleCloseEditTenant = () => {
    setSelectCustomer(null);
    setOpenDialog(false);
  };

  const handleOpenDialog = (product: IVariantView) => {
    setSelectedProduct(product);
    setOpenDialogProduct(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialogProduct(false);
  };

  const handleOpenDeletePopup = (product: IVariantView) => {
    setProductToDelete(product);
    setOpenDeleteProduct(true);
  };

  const handleCloseDeletePopup = () => {
    setProductToDelete(null);
    setOpenDeleteProduct(false);
  };

  const handleOpenDeletePopupMI = (product: IMainItem) => {
    setProductToDeleteMI(product);
    setOpenDeleteProductMI(true);
  };

  const handleCloseDeletePopupMI = () => {
    setProductToDeleteMI(null);
    setOpenDeleteProductMI(false);
  };

  const handleAddProductClick = () => {
    navigate(`/product/create/${product?.id}`);
  };

  const [deleteCategory] = useDeleteProductMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteProduct(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the product");
    }
  };

  const [deleteCategoryMI] = useDeleteMainItemMutation();
  const handleDeleteMI = async (id: string) => {
    try {
      const response = await deleteCategoryMI(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteProductMI(false);
        navigate(`/main/item/list`);
      } else {
        setAlertMessage(response.message);
        setDeleteAlert(true);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the Product");
    }
  };

  const coursings: IVariantView[] = Array.isArray(productData?.data)
    ? (productData?.data as IVariantView[])
    : [];

  if (isLoading || categoryLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching product details data. Please try again later.
      </Typography>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={4} md={12} sm={12} xs={12}>
        <Card
          className={classes.profileViewPageBackColor}
          sx={{
            padding: 2,
            height: "100%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={2}
                      sx={{ padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Box className={classes.productBox}>
                          {product?.mainItemImg ? (
                            <img
                              src={product?.mainItemImg}
                              alt="img"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <FcPicture style={{ fontSize: 60 }} />
                          )}
                        </Box>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="h4" textAlign={"center"}>
                          {toProperCase(product?.mainItemName)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item lg={8} md={12} sm={12} xs={12}>
        <Card
          className={classes.profileViewPageBackColor}
          sx={{
            padding: 2,
            height: "100%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard} sx={{ minHeight: "415px" }}>
                <Grid container justifyContent={"space-between"} spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={1}
                      sx={{ padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          alignContent: "center",
                        }}
                      >
                        <Typography
                          variant="h4"
                          fontWeight="bold"
                          color="primary"
                          gutterBottom
                          // textTransform={"uppercase"}
                        >
                          Product Detail
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        {product && (
                          <Grid
                            container
                            spacing={1}
                            justifyContent="flex-end"
                            sx={{ display: "flex" }}
                          >
                            {/* <Grid item>
                              <Button
                                className={classes.viewButtonList}
                                onClick={() =>
                                  navigate(`/variant/view/${product?.id || ""}`)
                                }
                              >
                                <VisibilitySharpIcon
                                  className={classes.viewListIcon}
                                />
                              </Button>
                            </Grid> */}

                            <Grid item>
                              <Button
                                // variant="contained"
                                className={classes.editButtonList}
                                onClick={handleOpenEditTenant}
                              >
                                <EditSharpIcon
                                  className={classes.editListIcon}
                                />
                              </Button>
                            </Grid>
                            <Grid item>
                              <Button
                                // variant="contained"
                                className={classes.deleteButtonList}
                                onClick={() => handleOpenDeletePopupMI(product)}
                              >
                                <DeleteOutlineSharpIcon
                                  className={classes.deleteListIcon}
                                />
                              </Button>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ px: 2, pb: 3 }}
                      className={classes.titleGrid}
                    >
                      <Grid item xs={12}>
                        <Stack spacing={2}>
                          <Typography variant="subtitle1">
                            <strong>Name :</strong>{" "}
                            {toProperCase(product?.mainItemName)}
                          </Typography>

                          {product?.categoryId && (
                            <Typography variant="subtitle1">
                              <strong>Category :</strong>{" "}
                              {categoryMap.get(product.categoryId) || ""}
                            </Typography>
                          )}
                          {product?.mainItemShortDescription && (
                            <Typography variant="subtitle1">
                              <strong>Short Description :</strong>{" "}
                              {product.mainItemShortDescription}
                            </Typography>
                          )}

                          {product?.mainItemLongDescription && (
                            <Typography variant="subtitle1">
                              <strong>Long Description :</strong>{" "}
                              {product.mainItemLongDescription}
                            </Typography>
                          )}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Card>
      </Grid>

      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card
          className={classes.profileViewPageBackColor}
          sx={{
            padding: 2,
            height: "100%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard}>
                <Grid container justifyContent={"space-between"} spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={1}
                      sx={{
                        // borderBottom: 2,
                        padding: 2,
                      }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          alignContent: "center",
                        }}
                      >
                        <Typography
                          variant="h4"
                          fontWeight="bold"
                          color="primary"
                          gutterBottom
                          // textTransform={"uppercase"}
                        >
                          Variant
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Grid
                          container
                          spacing={1}
                          justifyContent="flex-end"
                          sx={{ display: "flex" }}
                        >
                          <Grid item>
                            <Button
                              // variant="contained"
                              className={classes.addNewButton}
                              onClick={handleAddProductClick}
                            >
                              Add Variant
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ px: 2, pb: 3 }}
                      className={classes.titleGrid}
                    >
                      {productIsLoading ? (
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={2}
                          >
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid
                                container
                                justifyContent={"space-between"}
                                spacing={1}
                                sx={{ borderBottom: 1, padding: 2 }}
                                className={classes.titleGrid}
                                alignContent={"center"}
                                textAlign={"center"}
                              >
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  height="10vh"
                                >
                                  <CircularProgress />
                                </Box>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : productIsError || coursings.length === 0 ? (
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={2}
                            sx={{ padding: 2, minHeight: 200 }}
                          >
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography
                                variant="subtitle1"
                                textAlign={"center"}
                              >
                                {isError
                                  ? "Error fetching data"
                                  : "No product available"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : (
                        coursings.map((row: IVariantView, index) => (
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            key={row.id}
                          >
                            <Card className={classes.stepperCardProductView}>
                              <CardContent>
                                <Grid
                                  container
                                  alignItems={"center"}
                                  alignContent={"center"}
                                  justifyContent={"center"}
                                  spacing={2}
                                  className={classes.titleGrid}
                                >
                                  <Grid item lg={2} md={4} sm={12} xs={12}>
                                    <Grid
                                      container
                                      spacing={2}
                                      alignItems={"center"}
                                      alignContent={"center"}
                                      justifyContent={"center"}
                                    >
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          justifyContent={"space-between"}
                                          spacing={1}
                                          sx={{ padding: 2 }}
                                          className={classes.titleGrid}
                                        >
                                          <Grid
                                            item
                                            className={
                                              classes.SelectImageTableBoxwithBorder2456
                                            }
                                          >
                                            {row.variantImg ? (
                                              <img
                                                src={row?.variantImg}
                                                alt="img"
                                                // alt={row.variantName.toLowerCase()}
                                                className={
                                                  classes.SelectImageTable12
                                                }
                                              />
                                            ) : (
                                              <FcPicture
                                                className={
                                                  classes.SelectImageTable
                                                }
                                              />
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item lg={10} md={8} sm={12} xs={12}>
                                    <Grid
                                      container
                                      justifyContent={"space-between"}
                                      spacing={2}
                                    >
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          justifyContent={"space-between"}
                                          spacing={1}
                                          sx={{ padding: 2 }}
                                          className={classes.titleGrid}
                                        >
                                          <Grid
                                            item
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-start",
                                              alignItems: "center",
                                              alignContent: "center",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              navigate(
                                                `/variant/view/${row.id}`
                                              )
                                            }
                                          >
                                            <Typography
                                              className={classes.cardTitle}
                                            >
                                              {row?.variantName}
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-end",
                                            }}
                                          >
                                            <Grid
                                              container
                                              spacing={1}
                                              justifyContent="flex-end"
                                              sx={{ display: "flex" }}
                                            >
                                              <Grid item>
                                                <Button
                                                  className={
                                                    classes.viewButtonList
                                                  }
                                                  onClick={() =>
                                                    navigate(
                                                      `/variant/view/${row.id}`
                                                    )
                                                  }
                                                >
                                                  <VisibilitySharpIcon
                                                    className={
                                                      classes.viewListIcon
                                                    }
                                                  />
                                                </Button>
                                              </Grid>
                                              <Grid item>
                                                <Button
                                                  // variant="contained"
                                                  className={
                                                    classes.editButtonList
                                                  }
                                                  onClick={() =>
                                                    handleOpenDialog(row)
                                                  }
                                                >
                                                  <EditSharpIcon
                                                    className={
                                                      classes.editListIcon
                                                    }
                                                  />
                                                </Button>
                                              </Grid>
                                              <Grid item>
                                                <Button
                                                  // variant="contained"
                                                  className={
                                                    classes.deleteButtonList
                                                  }
                                                  onClick={() =>
                                                    handleOpenDeletePopup(row)
                                                  }
                                                >
                                                  <DeleteOutlineSharpIcon
                                                    className={
                                                      classes.deleteListIcon
                                                    }
                                                  />
                                                </Button>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>

                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          justifyContent={"space-between"}
                                          spacing={5}
                                          sx={{ px: 2, pb: 3 }}
                                          className={classes.titleGrid}
                                        >
                                          <Grid
                                            item
                                            lg={4}
                                            md={6}
                                            sm={12}
                                            xs={12}
                                            // alignContent={"center"}
                                            direction={"column"}
                                          >
                                            <Typography variant="subtitle1">
                                              <span
                                                className={
                                                  classes.customerDetails
                                                }
                                              >
                                                Name :
                                              </span>{" "}
                                              {row?.variantName}
                                            </Typography>
                                            {row?.variantDisplayName && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Display Name :
                                                </span>{" "}
                                                {row?.variantDisplayName}
                                              </Typography>
                                            )}
                                            {row?.variantBrandId && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Brand :
                                                </span>{" "}
                                                {productBrandMap.get(
                                                  row?.variantBrandId
                                                ) || ""}
                                              </Typography>
                                            )}
                                            {row?.variantTagId.length > 0 && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Tags :
                                                </span>{" "}
                                                {row.variantTagId
                                                  .map(
                                                    (id) => tagMap.get(id) || ""
                                                  )
                                                  .join(", ")}
                                              </Typography>
                                            )}
                                            {row?.variantPrinterIds.length >
                                              0 && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Printer :
                                                </span>{" "}
                                                {row.variantPrinterIds
                                                  .map(
                                                    (id) =>
                                                      printerMap.get(id) || ""
                                                  )
                                                  .join(", ")}
                                              </Typography>
                                            )}
                                            {row?.categoryId && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Category :
                                                </span>{" "}
                                                {categoryMap.get(
                                                  row?.categoryId
                                                ) || ""}
                                              </Typography>
                                            )}
                                            {row?.variantUnit && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Conversion unit :
                                                </span>{" "}
                                                {convertUnit(row.variantUnit)}
                                              </Typography>
                                            )}
                                            {row?.packCount && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Pack Count :
                                                </span>{" "}
                                                {row?.packCount}
                                              </Typography>
                                            )}

                                            {row?.size && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Size :
                                                </span>{" "}
                                                {row?.size}
                                              </Typography>
                                            )}
                                          </Grid>

                                          <Grid
                                            item
                                            lg={4}
                                            md={6}
                                            sm={12}
                                            xs={12}
                                            // alignContent={"center"}
                                            direction={"column"}
                                          >
                                            {row?.cost && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Cost :
                                                </span>{" "}
                                                {row.cost !== null
                                                  ? `$${row.cost}`
                                                  : ""}
                                              </Typography>
                                            )}
                                            {row?.regularPrice && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Regular Price :
                                                </span>{" "}
                                                {row.regularPrice !== null
                                                  ? `$${row.regularPrice}`
                                                  : ""}
                                              </Typography>
                                            )}
                                            {row?.salePrice && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Sale Price :
                                                </span>{" "}
                                                {row.salePrice !== null
                                                  ? `$${row.salePrice}`
                                                  : ""}
                                              </Typography>
                                            )}
                                            {row?.orderNumber && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Order Number :
                                                </span>{" "}
                                                {row?.orderNumber}
                                              </Typography>
                                            )}

                                            {row?.isActive == true && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Active :
                                                </span>{" "}
                                                Yes
                                              </Typography>
                                            )}
                                            {row?.isOnSale == true && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Is Sale :
                                                </span>{" "}
                                                Yes
                                              </Typography>
                                            )}
                                            {row?.isPosDisplay == true && (
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Is Pos Display :
                                                </span>{" "}
                                                Yes
                                              </Typography>
                                            )}
                                            {row?.bgColor && (
                                              <Typography
                                                variant="subtitle1"
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 1,
                                                }}
                                              >
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Button Color:
                                                </span>
                                                <Chip
                                                  label="Button Color"
                                                  sx={{
                                                    backgroundColor:
                                                      row?.bgColor,
                                                    color: row?.bgColor,
                                                  }}
                                                />
                                              </Typography>
                                            )}
                                          </Grid>

                                          {row?.isLooping == true && (
                                            <Grid
                                              item
                                              lg={4}
                                              md={6}
                                              sm={12}
                                              xs={12}
                                              direction={"column"}
                                            >
                                              <Typography variant="subtitle1">
                                                <span
                                                  className={
                                                    classes.customerDetails
                                                  }
                                                >
                                                  Looping :
                                                </span>{" "}
                                                {
                                                  row?.loopingDetails
                                                    ?.shortTableName
                                                }
                                              </Typography>

                                              {row?.loopingDetails
                                                ?.tableColumns &&
                                                row.loopingDetails.tableColumns.filter(
                                                  (column) =>
                                                    column.value !== null
                                                ).length > 0 && (
                                                  <>
                                                    {row.loopingDetails.tableColumns
                                                      .filter(
                                                        (column) =>
                                                          column.value !== null
                                                      )
                                                      .map((column, index) => (
                                                        <Typography
                                                          key={index}
                                                          variant="subtitle1"
                                                        >
                                                          <span
                                                            className={
                                                              classes.customerDetails
                                                            }
                                                          >
                                                            {column.name} :
                                                          </span>{" "}
                                                          {column.type ===
                                                          "boolean"
                                                            ? column.value
                                                              ? "True"
                                                              : "False"
                                                            : column.value}
                                                        </Typography>
                                                      ))}
                                                  </>
                                                )}
                                            </Grid>
                                          )}

                                          {row?.storeDetails &&
                                            row?.storeDetails.length > 0 && (
                                              <Grid
                                                item
                                                lg={4}
                                                md={6}
                                                sm={12}
                                                xs={12}
                                                direction={"column"}
                                              >
                                                {row.storeDetails.map(
                                                  (column, index) => (
                                                    <Typography
                                                      key={index}
                                                      variant="subtitle1"
                                                    >
                                                      <span
                                                        className={
                                                          classes.customerDetails
                                                        }
                                                      >
                                                        {getStoreMap.get(
                                                          column.storeId
                                                        )}
                                                        {" : "}
                                                      </span>
                                                      {column.price !== null
                                                        ? `$${column.price}`
                                                        : ""}
                                                      {column.referenceNo && (
                                                        <span
                                                          style={{
                                                            float: "right",
                                                          }}
                                                          className={
                                                            classes.customerDetails
                                                          }
                                                        >
                                                          --{column.referenceNo}
                                                        </span>
                                                      )}
                                                    </Typography>
                                                  )
                                                )}
                                              </Grid>
                                            )}

                                          {(row?.variantShortDescription ||
                                            row?.variantLongDescription) && (
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              // alignContent={"center"}
                                              direction={"column"}
                                            >
                                              {row?.variantShortDescription && (
                                                <Typography variant="subtitle1">
                                                  <span
                                                    className={
                                                      classes.customerDetails
                                                    }
                                                  >
                                                    Short Description :
                                                  </span>{" "}
                                                  {row?.variantShortDescription}
                                                </Typography>
                                              )}
                                              {row?.variantLongDescription && (
                                                <Typography variant="subtitle1">
                                                  <span
                                                    className={
                                                      classes.customerDetails
                                                    }
                                                  >
                                                    Long Description :
                                                  </span>{" "}
                                                  {row?.variantLongDescription}
                                                </Typography>
                                              )}
                                            </Grid>
                                          )}
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </CardContent>
                              <Divider sx={{ mb: 2, mx: 2 }} />
                            </Card>
                          </Grid>
                        ))
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Card>
      </Grid>

      {selectCustomer && (
        <NewPopupTenant
          openModel={openDialog}
          handleCloseDialog={handleCloseEditTenant}
          data={product ?? undefined}
        />
      )}
      {selectedProduct && (
        <NewPopUpProduct
          openModel={openDialogProduct}
          handleCloseDialog={handleCloseDialog}
          data={selectedProduct}
        />
      )}
      {productToDelete && (
        <DeletePopup
          open={openDeleteProduct}
          handleCloseDelete={handleCloseDeletePopup}
          onConfirm={async () => {
            await handleDelete(productToDelete.id.toString());
          }}
          title="Delete Product"
          content={`Are you sure you want to delete "${productToDelete.variantName}"?`}
        />
      )}
      {productToDeleteMI && (
        <DeletePopup
          open={openDeleteProductMI}
          handleCloseDelete={handleCloseDeletePopupMI}
          onConfirm={async () => {
            await handleDeleteMI(productToDeleteMI.id.toString());
          }}
          title="Delete Product"
          content={`Are you sure you want to delete "${productToDeleteMI.mainItemName}"?`}
        />
      )}

      <AlertPopUp
        open={deleteAlert}
        onCloseAlert={setDeleteAlert}
        message={alertMessage}
      />
    </Grid>
  );
};

export default Index;
